import React from 'react'
import PropTypes from 'prop-types'

const Svg = ({ style, className }) => (
	<svg
		width="30"
		height="32"
		viewBox="0 0 30 32"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		style={style}
		className={className}
	>
		<path
			opacity="0.3"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M25 30L19.2024 19.712C18.9289 19.2726 18.4697 19.0061 17.9757 19.0001C17.4817 18.9941 17.0169 19.2494 16.7341 19.682L12.7592 25.7473L10.2954 23.6367C9.96843 23.3568 9.54638 23.2366 9.13231 23.3053C8.71824 23.374 8.35025 23.6253 8.11817 23.9979L5 30"
			fill="#B29EFA"
			className="u-scheme-color"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7 11C7 8.79086 8.79086 7 11 7C13.2091 7 15 8.79086 15 11C15 13.2091 13.2091 15 11 15C8.79086 15 7 13.2091 7 11ZM11 9C9.89543 9 9 9.89543 9 11C9 12.1046 9.89543 13 11 13C12.1046 13 13 12.1046 13 11C13 9.89543 12.1046 9 11 9Z"
			fill="#B29EFA"
			className="u-scheme-color"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M2 3C2 1.34315 3.34315 0 5 0H20.9049C21.9785 0 23.0071 0.431593 23.7592 1.19771L26.8543 4.35029C27.5886 5.09821 28 6.10446 28 7.15258V29C28 30.6569 26.6569 32 25 32H5C3.34315 32 2 30.6569 2 29V3ZM5 2H20.9049C21.4417 2 21.956 2.2158 22.332 2.59885L25.4272 5.75144C25.7943 6.1254 26 6.62852 26 7.15258V29C26 29.1822 25.9513 29.353 25.8661 29.5001L20.0735 19.221C20.0664 19.2084 20.059 19.1959 20.0513 19.1836C19.6079 18.4712 18.842 18.0105 17.9878 18.0002C17.1337 17.9898 16.3572 18.4316 15.8977 19.1339L12.5461 24.248L10.9456 22.8769C10.4007 22.4106 9.68256 22.2003 8.9686 22.3188C8.25651 22.4369 7.64544 22.8654 7.26932 23.4692C7.25558 23.4913 7.24271 23.5138 7.23074 23.5369L4.13328 29.4991C4.0485 29.3522 4 29.1818 4 29V3C4 2.44772 4.44772 2 5 2ZM6.12686 30H23.8521L18.3443 20.2263C18.2411 20.07 18.0934 20.0016 17.9635 20C17.83 19.9984 17.6773 20.0667 17.5712 20.2291L13.5956 26.2954C13.438 26.5359 13.1845 26.6969 12.8999 26.7374C12.6152 26.7778 12.327 26.6938 12.1086 26.5067L9.64518 24.3964C9.53609 24.3031 9.41012 24.2729 9.29595 24.2918C9.18691 24.3099 9.07003 24.3765 8.98328 24.5017L6.12686 30Z"
			fill="#B29EFA"
			className="u-scheme-color"
		/>
	</svg>
)

Svg.propTypes = {
	style: PropTypes.string,
	className: PropTypes.string,
}

Svg.defaultProps = {
	style: null,
	className: null,
}

export default Svg
